'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisjunctiveAvailabilityIterator = exports.DisjunctiveTimeWindowsIterator = exports.UnmergedDisjunctiveTimeWindowsIterator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AvailabilityIterator = require('./AvailabilityIterator');

var _MergingStatusIterator = require('./MergingStatusIterator');

var _DateTimeWindowsUtils = require('./DateTimeWindowsUtils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnmergedDisjunctiveTimeWindowsIterator = exports.UnmergedDisjunctiveTimeWindowsIterator = function () {
    /**
     * @param availabilities   List<availability.Availability>
     * @param cal              Moment with tz
     */
    function UnmergedDisjunctiveTimeWindowsIterator(_ref) {
        var _this = this;

        var _ref$iterators = _ref.iterators,
            iterators = _ref$iterators === undefined ? [] : _ref$iterators,
            cal = _ref.cal;

        _classCallCheck(this, UnmergedDisjunctiveTimeWindowsIterator);

        this._now = cal.valueOf();
        this._nextStatus = null;

        this._wrapped = [];
        iterators.forEach(function (it) {
            _this._wrapped.push({
                it: it,
                nextStatus: it.next() // There's always at least one status
            });
        });

        this._advanceNextStatus();
    }

    /** @return Boolean */


    _createClass(UnmergedDisjunctiveTimeWindowsIterator, [{
        key: 'hasNext',
        value: function hasNext() {
            return this._nextStatus !== null;
        }

        /** @return Status */

    }, {
        key: 'next',
        value: function next() {
            var nextStatus = this._nextStatus;
            this._advanceNextStatus();
            return nextStatus;
        }
    }, {
        key: '_advanceNextStatus',
        value: function _advanceNextStatus() {
            // Last status?
            if (this._nextStatus !== null && this._nextStatus.until === null) {
                this._nextStatus = null;
                return;
            }

            // Advance
            var earliestUnavailableUntil = null;

            for (var i = 0, l = this._wrapped.length; i < l; ++i) {
                var wrapped = this._wrapped[i];

                while (wrapped.nextStatus !== null && (0, _DateTimeWindowsUtils.strictlyBefore)(wrapped.nextStatus.until, this._now)) {
                    wrapped.nextStatus = wrapped.it.hasNext() ? wrapped.it.next() : null;
                }

                if (wrapped.nextStatus !== null) {
                    if (wrapped.nextStatus.status === 'available') {
                        this._now = wrapped.nextStatus.until;
                        this._nextStatus = wrapped.nextStatus;
                        return;
                    } else {
                        if (wrapped.nextStatus.until !== null) {
                            earliestUnavailableUntil = earliestUnavailableUntil !== null ? Math.min(earliestUnavailableUntil, wrapped.nextStatus.until) : wrapped.nextStatus.until;
                        }
                    }
                }
            }

            this._now = earliestUnavailableUntil;
            this._nextStatus = {
                status: 'unavailable',
                until: earliestUnavailableUntil
            };
        }
    }]);

    return UnmergedDisjunctiveTimeWindowsIterator;
}();

var DisjunctiveTimeWindowsIterator = exports.DisjunctiveTimeWindowsIterator = function () {
    function DisjunctiveTimeWindowsIterator(_ref2) {
        var _ref2$iterators = _ref2.iterators,
            iterators = _ref2$iterators === undefined ? [] : _ref2$iterators,
            cal = _ref2.cal;

        _classCallCheck(this, DisjunctiveTimeWindowsIterator);

        this._it = new _MergingStatusIterator.MergingStatusIterator({
            it: new UnmergedDisjunctiveTimeWindowsIterator({ iterators: iterators, cal: cal }),
            maxIterations: 1000
        });
    }

    /** @return Boolean */


    _createClass(DisjunctiveTimeWindowsIterator, [{
        key: 'hasNext',
        value: function hasNext() {
            return this._it.hasNext();
        }

        /** @return Status */

    }, {
        key: 'next',
        value: function next() {
            return this._it.next();
        }
    }]);

    return DisjunctiveTimeWindowsIterator;
}();

var DisjunctiveAvailabilityIterator = exports.DisjunctiveAvailabilityIterator = function () {
    /**
     * @param availabilities   List<availability.Availability>
     * @param cal              Moment with tz
     */
    function DisjunctiveAvailabilityIterator(_ref3) {
        var _ref3$availabilities = _ref3.availabilities,
            availabilities = _ref3$availabilities === undefined ? [] : _ref3$availabilities,
            cal = _ref3.cal;

        _classCallCheck(this, DisjunctiveAvailabilityIterator);

        availabilities = availabilities || []; // null availabilities are treated as empty array

        var iterators = availabilities.map(function (availability) {
            return new _AvailabilityIterator.AvailabilityIterator({ availability: availability, cal: cal });
        });

        this._it = new DisjunctiveTimeWindowsIterator({ iterators: iterators, cal: cal });
    }

    /** @return Boolean */


    _createClass(DisjunctiveAvailabilityIterator, [{
        key: 'hasNext',
        value: function hasNext() {
            return this._it.hasNext();
        }

        /** @return Status */

    }, {
        key: 'next',
        value: function next() {
            return this._it.next();
        }
    }]);

    return DisjunctiveAvailabilityIterator;
}();